import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "info-page-content wiki-page" }
const _hoisted_2 = { class: "addon-overview" }
const _hoisted_3 = { class: "addon-rules" }
const _hoisted_4 = { class: "wiki-panel addon-limits" }
const _hoisted_5 = { class: "addon-scenarios" }
const _hoisted_6 = ["aria-label"]

import WikiBreadCrumbs from '@/components/header/WikiBreadCrumbs.vue';
import SchemaImage from '@/components/view/SchemaImage.vue';
import LocalizedTextWrapper from '@/components/feedback/LocalizedTextWrapper.vue';
import WikiPlayCta from '@/components/view/information/WikiPlayCta.vue';
import { getImagePathByID } from '@/helpers/images';

export default /*@__PURE__*/_defineComponent({
  __name: 'LadyOfTheSea',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_LocaleLink = _resolveComponent("LocaleLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(WikiBreadCrumbs),
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('ladySea.seoHeading')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SchemaImage, {
        class: "addon-image",
        src: _unref(getImagePathByID)('features', 'lady_of_sea'),
        alt: _ctx.$t('addons.ladyOfSea'),
        description: _ctx.$t('addons.ladyOfSea')
      }, null, 8, ["src", "alt", "description"]),
      _createElementVNode("p", null, [
        _createVNode(LocalizedTextWrapper, { keypath: "ladySea.seoIntro" })
      ])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('wiki.rules')), 1),
      _createElementVNode("ol", null, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (number) => {
          return _createElementVNode("li", { key: number }, [
            _createVNode(LocalizedTextWrapper, {
              keypath: `ladySea.seoRule${number}`
            }, null, 8, ["keypath"])
          ])
        }), 64))
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('wiki.roleLimit')), 1),
      _createElementVNode("p", null, [
        _createVNode(LocalizedTextWrapper, { keypath: "ladySea.seoLimit1" })
      ]),
      _createElementVNode("p", null, [
        _createVNode(LocalizedTextWrapper, { keypath: "ladySea.seoLimit2" })
      ])
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('wiki.roleScenarios')), 1),
      _createElementVNode("ul", null, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (number) => {
          return _createElementVNode("li", { key: number }, [
            _createVNode(LocalizedTextWrapper, {
              keypath: `ladySea.seoScenario${number}`
            }, null, 8, ["keypath"])
          ])
        }), 64))
      ])
    ]),
    _createElementVNode("nav", {
      class: "wiki-nav",
      "aria-label": _ctx.$t('wiki.title')
    }, [
      _createVNode(_component_LocaleLink, { to: { name: 'expansions' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('wiki.addonsTitle')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, { to: { name: 'roles' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('wiki.rolesTitle')), 1)
        ]),
        _: 1
      })
    ], 8, _hoisted_6),
    _createVNode(WikiPlayCta)
  ]))
}
}

})